module.exports = __webpack_public_path__ + "static/media/bg7.e3acbd49.jpg";